import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ChatbotBlackList } from "./components/ChatbotBlackList";
import { ChatbotChatsTable } from "./components/ChatbotChatsTable";
import { ChatbotWhiteList } from "./components/ChatbotWhiteList";
import { ChatbotMainInfo } from "./components/ChatbotMainInfo";
import { ChatbotSecurity } from "./components/ChatbotSecurity";
import { AddNewBotModal } from "../AppNewBotDialog";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useUpdateStorageValue } from "../../../../app/state/storageObjectSlice/hook/use-update-storage-value";
import { setChatbotValue } from "../../redux/slice";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { useInitAssistantOptions } from "../../../../common/Components/Selects/hooks/use-init-assistants-options";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { ChangeChatAssistantModal } from "../ChangeChatAssistantModal";
import { selectLoading } from "../../redux/selectors";
import { useChatsByRef } from "../../hook/use-chat-by-ref";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";
import classNames from "classnames";

export const ChatbotMain = () => {
  const { assistants } = useInitAssistantOptions();
  const { selectedObject, objects } = useStorageSelectors(
    "ai_agents_telegram_bots",
  );
  const { saveValue } = useUpdateStorageValue(
    "ai_agents_telegram_bots",
    setChatbotValue,
  );
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const chats = useChatsByRef(selectedObject?.value?.tg_bot_object?.ref);
  const isLoading = useAppSelector(selectLoading);
  const changeAssistantModal = useModalSelectors("change_chat_assistant_modal");
  const { t } = useTranslation();

  const value = useMemo(() => {
    if (!selectedObject?.value) return null;
    return selectedObject.value.tg_bot_object;
  }, [selectedObject?.id]);

  if (!selectedObject) {
    return <div>Нет данных по боту</div>;
  }

  return (
    <div
      className={classNames(
        styles.container,
        !selectedObject?.write && styles.disabled,
      )}
    >
      <ChatbotMainInfo
        assistants={assistants}
        bot={selectedObject}
        saveChatbotValue={saveValue}
        handleChangeApi={() =>
          handleOpenModal("add_new_bot_modal", null, "change")
        }
      />
      <ChatbotSecurity
        bots={objects}
        bot={selectedObject}
        saveChatbotValue={saveValue}
      />
      <ChatbotWhiteList bot={selectedObject} saveChatbotValue={saveValue} />
      <ChatbotBlackList bot={selectedObject} saveChatbotValue={saveValue} />
      <ChatbotChatsTable
        assistants={assistants}
        handleOpenChangeChatAssistantModal={handleOpenModal}
        chats={chats ?? []}
        isLoading={isLoading}
        title={t("chatbot.table_title")}
      />
      <AddNewBotModal
        addBotModalType={"change"}
        closeModal={handleCloseModal}
      />
      <ChangeChatAssistantModal
        asstId={changeAssistantModal?.info?.value ?? ""}
        assistants={assistants}
        closeModal={handleCloseModal}
      />
    </div>
  );
};
